/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Source_YoutubeInputs */

const en_new_project_media_source_youtube = /** @type {(inputs: New_Project_Media_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const fr_new_project_media_source_youtube = /** @type {(inputs: New_Project_Media_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const de_new_project_media_source_youtube = /** @type {(inputs: New_Project_Media_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const it_new_project_media_source_youtube = /** @type {(inputs: New_Project_Media_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const ru_new_project_media_source_youtube = /** @type {(inputs: New_Project_Media_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const es_new_project_media_source_youtube = /** @type {(inputs: New_Project_Media_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const zh_cn2_new_project_media_source_youtube = /** @type {(inputs: New_Project_Media_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const ja_new_project_media_source_youtube = /** @type {(inputs: New_Project_Media_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーチューブ`)
};

const hi_new_project_media_source_youtube = /** @type {(inputs: New_Project_Media_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यूट्यूब`)
};

const pt_pt2_new_project_media_source_youtube = /** @type {(inputs: New_Project_Media_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

/**
* | output |
* | --- |
* | "YouTube" |
*
* @param {New_Project_Media_Source_YoutubeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_source_youtube = /** @type {((inputs?: New_Project_Media_Source_YoutubeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Source_YoutubeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_media_source_youtube(inputs)
	if (locale === "de") return de_new_project_media_source_youtube(inputs)
	if (locale === "it") return it_new_project_media_source_youtube(inputs)
	if (locale === "ru") return ru_new_project_media_source_youtube(inputs)
	if (locale === "es") return es_new_project_media_source_youtube(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_media_source_youtube(inputs)
	if (locale === "ja") return ja_new_project_media_source_youtube(inputs)
	if (locale === "hi") return hi_new_project_media_source_youtube(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_media_source_youtube(inputs)
	return en_new_project_media_source_youtube(inputs)
});